import { extend, buffer, createEmpty, getCenter, isEmpty } from 'ol/extent';
import { transformExtent } from 'ol/proj';

const extent = {
	extend, buffer, createEmpty, getCenter, transformExtent, isEmpty
};


export {
	extent
}